<template>
  <div
    class="app-selector d-flex flex-column h-100 pt-5"
  >
    <!--
  <div class="d-flex justify-content-center align-items-center">
      <b-img
        :src="logo"
        class="logo px-3"
      />
    </div>
    -->

    <!--   <div class="search w-100 mx-auto my-3 px-5">
      <div class="flex-grow-1 mt-1">
        <c-input-search
          v-model.trim="query"
          data-v-onboarding="app-list"
          :aria-label="$t('search')"
          :placeholder="$t('search')"
          :debounce="200"
        />
      </div>
    </div>
    -->

    <div
      class="flex-fill overflow-auto"
    >
      <div
        class="box-tiles"
      >
        <div class="col-12 mb-3">
          <div class="maincard">
            <div class="row iconic_cards">
              <h2 class="color_heading pl-3">
                Modules
              </h2>
              <draggable
                v-if="appLayouts['Module'] && Array.isArray(appLayouts['Module']) && appLayouts['Module'].length"
                v-model="appList"
                :disabled="!canCreateApplication || query || isMobileResolution"
                group="apps"
                class="h-100 w-100"
                @end="onDrop"
              >
                <transition-group
                  name="apps"
                  tag="b-row"
                  class="d-flex flex-wrap align-items-stretch justify-content-start mx-2"
                >
                  <b-col
                    v-for="app in appLayouts['Module']"
                    :key="app.applicationID"
                    cols="12"
                    sm="6"
                    md="6"
                    lg="3"
                    xl="3"
                    class="p-0 mb-3 mt-1"
                    :data-v-onboarding="getStepName(app.unify.url)"
                  >
                    <b-card
                      no-body
                      overlay
                      class=" smallcardlevel h-100 justify-content-center"
                      @mouseover="hovered = app.applicationID"
                      @mouseleave="hovered = undefined"
                    >
                      <div class="row align-items-center justify-content-center">
                        <div class="col-auto">
                          <b-card-img
                            class="logo-height thumbnail"
                            :src="logoUrl(app)"
                            :alt="app.unify.name || app.name"
                          />
                        </div>
                        <div class="col-auto p-0 pr-3">
                          <p class="text-start font-size-text text-dark my-4">
                            {{ app.unify.name || app.name }}
                          </p>
                          <b-link
                            :data-test-id="app.name"
                            :disabled="!app.enabled"
                            :href="app.unify.url"
                            :target="openAppInNewTab(app.unify.url)"
                            :style="[{ cursor: `${app.enabled ? 'pointer' : canCreateApplication ? 'grab' : 'default'}` }]"
                            class="stretched-link"
                          />
                        </div>
                      </div>
                    </b-card>
                  </b-col>
                </transition-group>
              </draggable>
            </div>
          </div>
        </div>
        <div
          class="row row_card_style"
        >
          <div class="col-12 col-lg-6 mb-3">
            <div
              class="smallcardheight"
              style="box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);"
            >
              <h2 class="color_heading mb-3 pt-4">
                Core Functions
              </h2>
              <div
                v-if="appLayouts['Core'] && Array.isArray(appLayouts['Core']) && appLayouts['Core'].length"
                class="w-100 justify-content-center"
              >
                <b-col
                  v-for="app in appLayouts['Core']"
                  :key="app.applicationID"
                  cols="8"
                  class="p-0 mb-3 mt-1 mx-auto"
                  :data-v-onboarding="getStepName(app.unify.url)"
                >
                  <b-card
                    no-body
                    overlay
                    class="app smallcard h-70 justify-content-center"
                    @mouseover="hovered = app.applicationID"
                    @mouseleave="hovered = undefined"
                  >
                    <p
                      class="text-center coreheadings"
                    >
                      {{ app.unify.name || app.name }}
                    </p>

                    <b-link
                      :data-test-id="app.name"
                      :disabled="!app.enabled"
                      :href="app.unify.url"
                      :target="openAppInNewTab(app.unify.url)"
                      :style="[{ cursor: `${app.enabled ? 'pointer': canCreateApplication ? 'grab' : 'default'}` }]"
                      class="stretched-link"
                    />
                  </b-card>
                </b-col>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-3 mb-3 pr-md-0 pl-lg-0">
            <div
              class="smallcardheight"
              style="display: flex; box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);"
            >
              <div
                class="h-100 w-100"
              >
                <div
                  class="p-0 mb-3 mt-1"
                >
                  <h2 class="color_heading pt">
                    Help
                  </h2>
                  <hr
                    class="hr_tag_header"
                  >
                  <b-col
                    v-for="app in appLayouts['Help']"
                    :key="app.applicationID"
                    cols="12"
                    class="m-0 p-0"
                    :data-v-onboarding="getStepName(app.unify.url)"
                  >
                    <p class="cardheadings">
                      {{ app.unify.name || app.name }}  <span class="floatSign">></span>
                      <b-link
                        :data-test-id="app.name"
                        :disabled="!app.enabled"
                        :href="app.unify.url"
                        :target="openAppInNewTab(app.unify.url)"
                        :style="[{ cursor: `${app.enabled ? 'pointer': canCreateApplication ? 'grab' : 'default'}` }]"
                        class="stretched-link"
                      />
                    </p>
                    <hr class="hr_tag">
                  </b-col>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-3 mb-3">
            <div
              class="smallcardheight"
              style="display: flex; box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);"
            >
              <div
                class="h-100 w-100"
              >
                <div
                  class="p-0 mb-3 mt-1"
                >
                  <h2 class="color_heading pt">
                    Settings
                  </h2>
                  <hr
                    class="hr_tag_header"
                  >
                  <b-col
                    v-for="app in appLayouts['Setting']"
                    :key="app.applicationID"
                    cols="12"
                    class="m-0 p-0"
                    :data-v-onboarding="getStepName(app.unify.url)"
                  >
                    <p class="cardheadings">
                      {{ app.unify.name || app.name }}  <span class="floatSign">></span>
                      <b-link
                        :data-test-id="app.name"
                        :disabled="!app.enabled"
                        :href="app.unify.url"
                        :target="openAppInNewTab(app.unify.url)"
                        :style="[{ cursor: `${app.enabled ? 'pointer': canCreateApplication ? 'grab' : 'default'}` }]"
                        class="stretched-link"
                      />
                    </p>
                    <hr class="hr_tag">
                  </b-col>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Draggable from 'vuedraggable'
import { url } from '@prvidrgo/manage-vue'

export default {
  i18nOptions: {
    namespaces: 'layout',
  },

  components: {
    Draggable,
  },

  props: {
    logo: {
      type: String,
      default: () => '',
    },
  },

  data () {
    return {
      query: '',

      appList: [],

      canCreateApplication: false,
      canPin: false,

      hovered: undefined,

      isMobileResolution: false,

      steps: [
        { name: 'app-list', dynamic: false },
        { name: 'low-code', dynamic: true },
        { name: 'crm', dynamic: true },
        { name: 'reporter', dynamic: true },
        { name: 'workflow', dynamic: true },
        { name: 'profile', dynamic: false },
      ],

    }
  },

  computed: {
    ...mapGetters({
      apps: 'applications/unifyOnly',
    }),

    filteredApps () {
      const query = (this.query || '').toUpperCase()
      return this.query
        ? this.appList.filter(({ name }) => (name.toUpperCase()).includes(query))
        : this.appList
    },

    appLayouts () {
      const layouts = {}

      this.filteredApps.forEach(app => {
        // Check if config is empty or a blank string and skip it
        if (!app.unify.config || app.unify.config.trim() === '') {
          return // Skip this app if config is empty or just whitespace
        }

        let config = {}
        try {
          // Parse the app's config JSON
          config = JSON.parse(app.unify.config)
        } catch (error) {
          // Log the error for debugging purposes
          // eslint-disable-next-line
          console.error('Error parsing app config for app:', app.name, error)
          return // Skip this app if parsing the config fails
        }

        // Group apps by their layout property if it exists
        if (config.layout) {
          const layoutType = config.layout
          if (!layouts[layoutType]) {
            layouts[layoutType] = []
          }
          layouts[layoutType].push(app)
        }
      })

      return layouts
    },

    filteredSteps () {
      return this.steps.filter(step => {
        if (step.dynamic) {
          return this.filteredApps.some(app => {
            return this.getStepName(app.unify.url) === step.name
          })
        }
        return true
      }).map(s => { return s.name })
    },
  },

  watch: {
    'apps': {
      immediate: true,
      handler (apps) {
        this.appList = apps
        this.urlPatternMatch()
      },
    },
  },

  created () {
    this.fetchEffective()
    if (window.innerWidth < 576) {
      this.isMobileResolution = true
    }
  },

  methods: {
    ...mapActions({
      reorderApp: 'applications/reorder',
      pinApp: 'applications/pin',
      unpinApp: 'applications/unpin',
    }),

    urlPatternMatch () {
      this.filteredApps.forEach(app => {
        app.unify.url = app.unify.url.replace(/\$\{([^}]+)\}/g, (match, key) => {
          if (key === 'userID') {
            return this.$auth.user ? this.$auth.user.userID : ''
          } else {
            return ''
          }
        })
      })
    },

    getStepName (url) {
      switch (url) {
        case 'compose/':
          return 'low-code'
        case 'compose/ns/crm/pages':
          return 'crm'
        case 'reporter/':
          return 'reporter'
        case 'workflow/':
          return 'workflow'
      }
    },

    fetchEffective () {
      this.$SystemAPI.permissionsEffective({ resource: 'application' })
        .then(p => {
          this.canCreateApplication = p.find(per => per.operation === 'application.create').allow || false
          // this.canPin = p.find(({ resource, operation, allow }) => resource === 'system' && operation === 'application.flag.self').allow
        })
    },

    handlePin (pin = true, applicationID) {
      if (pin) {
        this.unpinApp({ applicationID, ownedBy: this.$auth.user.userID })
      } else {
        this.pinApp({ applicationID, ownedBy: this.$auth.user.userID })
      }
    },

    async onDrop () {
      const applicationIDs = this.appList.map(({ applicationID }) => applicationID)
      await this.reorderApp(applicationIDs)
    },

    logoUrl (app) {
      if (!app.unify.logo) {
        return 'applications/default-app.png'
      }

      const apiSystem = '/api/system'
      const apiBaseUrl = (new URL(url.Make({ url: this.$SystemAPI.baseURL }))).toString()

      // Properly handle uploaded logos
      // but cut away only /api/system (without any potential base-url prefix)
      if (app.unify.logo.startsWith(apiSystem)) {
        // remove path from the URL
        return apiBaseUrl.substring(0, apiBaseUrl.length - apiSystem.length) + app.unify.logo
      }

      // Provisioned app logos
      return app.unify.logo
    },

    openAppInNewTab (route) {
      return !route.includes('jitsi') ? '' : '_blank'
    },
  },
}
</script>
<style lang="scss" scoped>
.app-selector {
  .logo {
    max-height: 20vh;
    max-width: 500px;
    width: auto;
    background-color: var(--body-bg);
  }

  @media only screen and (max-width: 576px) {
    .logo {
      max-width: 100%;
    }
  }

  .search {
    max-width: 600px;
  }

  .app {
    min-height: 5rem;
    transition: all 0.2s ease;
    box-shadow: 0;
    top: 0;
    margin: 0 0.625rem;

    .thumbnail {
      max-width: 100%;
      max-height: 150px;
      object-fit: contain;
    }

    &:hover {
      transition: all 0.2s ease;
      box-shadow: 0px 4px 8px rgba(38, 38, 38, 0.2);
      top: -2px;
    }
  }

  .star {
    position: absolute;
    top: .2rem;
    left: .2rem;
    padding: 0;
    margin: 0;
    background-color: transparent;
    border: none;
    .star-icon {
      fill: var(--warning);
      width: 1.2rem;
      height: 1.2rem;
    }
  }

  .apps-leave-active {
    position: absolute;
    transition: opacity 0.25s ease;
  }
  .apps-enter, .apps-leave-to {
    opacity: 0;
  }

  .apps-move {
    transition: transform 0.25s ease;
  }
  .maincard{
    background-color : var(--tail-bg);
    border-radius: 10px;
    margin-top : 6px;
    box-shadow: 2px 2px 4px rgba(38, 38, 38, 0.1);
}
.iconic_cards{
    padding: 30px;
}
.smallcard{
    box-shadow: 0px 2px 4px rgba(38, 38, 38, 0.1);
}
.smallcard:hover{
    border: 2px solid #23bcae;
    box-shadow: 0px 4px 8px rgba(38, 38, 38, 0.2);
}
.box-tiles{
  width : 90%;
  max-width: 1420px;
  margin: auto !important;
}
.cardheadings{
  padding: .7em 2em;
  font-size: 1.2em;
  color: var(--tail-text);
  margin: 0 !important;

    &:hover{
      color: #1B9C91;
    }
}
.coreheadings{
  padding: .7em 2em;
  font-size: 1.2em;
  color: #1B9C91;
  margin: 0 !important;
}
.primary-color{
  color: var(--primary);
}
.secondary-color{
  color: var(--secondary);
}
.smallcardheight{
  background-color : var(--tail-bg);
  box-shadow: 2px 2px 4px rgba(38, 38, 38, 0.1);
  height : 320px;
  border-radius: 10px;
  overflow: auto;
}
.row_card_style{
  margin-right : -2px;
  margin-left : -1.5px;
}
.hr_tag{
  width : auto;
  margin : auto 2em !important;
}
.hr_tag_header{
  width : auto;
  margin : auto 2em !important;
  border-top: 2px solid rgba(22, 36, 37, 0.1);
}
.color_heading{
  color : #1B9C91;
  margin: 0;
  font-size: 1.4em;
  padding: .7em 1.4em;
}
.smallcardlevel{
  min-height: 12rem;
  transition: all 0.2s ease;
  box-shadow: 0px 2px 4px rgba(38, 38, 38, 0.1);
  top: 0;
  margin: 0 0.625rem;

    .thumbnail {
      max-width: 100%;
      max-height: 150px;
      object-fit: contain;
    }

    &:hover {
      transition: all 0.2s ease;
      top: -2px;
      border: 2px solid #23bcae;
      box-shadow: 0px 4px 8px rgba(38, 38, 38, 0.2);
    }
}
.logo-height{
  height: 47px;
  border-radius: 0 !important
}
.font-size-text{
  font-size: 2em;
}
.floatSign{
  float: right;
  margin-auto: 30px !important;
  color: #1B9C91 !important;
}
.pt{
  padding-top : 25px;
}
}
</style>
